import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";

/** Clears the admin cookie on the server, then back to the sign-in page. */
export function SignOutButton() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="s-btn"
      onClick={async () => {
        await api.logout().catch(() => {});
        navigate("/login", { replace: true });
      }}
    >
      Sign out
    </button>
  );
}
